import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { TeaserDownloadDocumentListTemplate } from "../../partial-templates/teaser/download/teaser-download.templates";
import { productImageSlider } from "../../partial-templates/slider/slider.stories";
import { getDummyText } from "../../../utils";
import { renderPageWithMarginalColumnTemplate } from "../../../utils";

export default {
    title: "Website/Page Templates/News Detail",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html`
        <div class="ux-row ux-u-text-align--center ux-u-mb-fluid-m">
            <div class="ux-col-10 ux-u-offset-1">
                <h3 class="ux-text-headline ux-text-headline--small">
                    25.06.2024
                </h3>
                <h1 class="ux-u-m-zero">
                    Battery Show Europe: TRUMPF TruHeat VCSEL Trocknungslösungen
                    für eine fortschrittliche, kosteneffiziente
                    Elektrodenfertigung
                </h1>
                <p>${getDummyText(500)}</p>
            </div>
        </div>
        <div class="ux-row ux-u-mb-fluid-m">
            <div class="ux-row">
                <div class="ux-col-10 ux-u-offset-1">
                    <div class="ux-row">
                        ${TeaserDownloadDocumentListTemplate({
                            withImage: true,
                        })}
                    </div>
                </div>
            </div>
        </div>
        <div class="ux-row ux-u-text-align--center ux-u-mb-fluid-m">
            <div class="ux-col-12">${productImageSlider()}</div>
        </div>
    `;
};

export const Default = () =>
    renderPageWithMarginalColumnTemplate(() => Template());
